var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform_wrap"},_vm._l((_vm.platformList),function(item,idx){return _c('span',{key:item.value,class:[_vm.checkIdx === idx ? 'checked' : ''],on:{"click":function($event){return _vm.clickItem(item, idx)}}},[_vm._v(_vm._s(item.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }